import { Stack } from '@cheqroom/ui';
import tw, { css, styled } from 'twin.macro';

/** Scrollable list container: max height, overflow, inset shadow when more than three items. */
export const StyledScrollableStack = styled(Stack).attrs({ element: 'ul' })<{ amountOfItems: number }>(
	({ amountOfItems }) => [
		tw`w-full max-h-[265px] overflow-y-auto p-4`,
		amountOfItems > 3 &&
			css`
				box-shadow: inset 0px -24px 4px -20px rgba(15, 23, 42, 0.05);
			`,
	]
);
